export default __webpack_public_path__ + "static/optimise-f72564fc9a3de46963382ae60afeb96f.png";